import Vue from 'vue';
import store from "../store";

const bus = new Vue({

    data(){
        return {
            modals: []
        }
    },
    created(){
        this.$on('modal.open', (str)=>{
            if(!this.modals.includes(str)){
                if(this.modals.length==0) document.body.classList.add('modal-open')
                this.modals.push(str);
            }
        });
        this.$on('modal.close', (str)=>{
            this.modals.splice(this.modals.indexOf(str), 1);
            if(this.modals.length==0) document.body.classList.remove('modal-open');
        });
        this.$on('track.click', (trackObj)=>{
            if(store.state.user.data.id) _paq.push(['setUserId', store.state.user.data.name]);//store.state.user.data.id]);
            _paq.push(['setCustomUrl', trackObj.path]);
            _paq.push(['setDocumentTitle', trackObj.title]);
            _paq.push(['trackPageView']);
        });

        this.$on('track.event', (trackObj)=>{
          _paq.push(['trackEvent', trackObj.name, trackObj.data]);
        });

        this.$on('user.login', ()=>{
            this.$socket.emit('isOnline', {
                token: store.state.user.token,
            })
        });

        this.$on('user.logout', ()=>{
            this.$socket.emit('isOffline', {
                token: store.state.user.token,
            })
        });

    }

});

export default bus;



// WEBPACK FOOTER //
// ./src/services/EventBus.js